import SYMPTOMS from 'modules/constants/booking/symptoms';
import { AppName, CompanyName, getAppName } from 'modules/utils/ConfigUtils';

const EMERGENCY_SYMPTOMS = SYMPTOMS.SYMPTOMS;

export default {
  COVID_DIALOG_TYPOGRAPHY: [
    `In many situations, a video visit can be an excellent way to practice social distancing while getting the healthcare you need. At ${CompanyName}, we conduct thousands of video visits each day.`,
    `Review the guidelines below, and then, contact your provider today to schedule a video visit (or book an in-clinic visit directly through ${getAppName(
      AppName.secondary,
      'the'
    )}.`
  ],
  COVID_DIALOG_TITLE_ONE: ['A video visit is recommended:'],
  COVID_DIALOG_TITLE_TWO: ['However, an in-person visit is required in the following situations:'],
  COVID_DIALOG_TITLE_THREE: [
    'Still uncertain about what option is best for you? Call your provider to discuss your situation further.'
  ],
  COVID_DIALOG_SUBTITLE_LIST_ONE: [
    'If you (or someone you live with has potential COVID-19 symptoms:'
  ],
  COVID_DIALOG_SUBTITLE_LIST_TWO: [
    'If you (or someone you live with) is at high risk of complications from COVID-19:'
  ],
  COVID_DIALOG_SUBTITLE_LIST_THREE: [
    'If you (or someone you live with has potential COVID-19 symptoms:'
  ],
  COVID_LIST_ITEMS_ONE: [
    'Fever',
    'New or worsening cough',
    'Shortness of breath',
    'Body ache(s)',
    'Reduced sense of smell',
    'Sore throat',
    'Diarrhea',
    'Runny or stuffy nose'
  ],
  COVID_LIST_ITEMS_TWO: [
    'Over 60 years old',
    'Receiving chemotherapy or other treatments for cancer or other diseases',
    'Have had bone marrow transplant',
    'Who are on immunosuppressive medication that purposefully suppresses your immune system -- for example, treatment for rheumatoid arthritis',
    'Taking opioid medications'
  ],
  COVID_LIST_ITEMS_THREE: [
    'Mental health visits',
    'Chronic disease follow-up',
    'Medicare annual wellness visits',
    'Acute and chronic conditions that require discussion and visualization but no hands-on exam or treatment'
  ],
  COVID_LIST_ITEMS_FOUR: [
    'Well child checks',
    'Routine physical exams',
    'Conditions or visits that require a treatment, such as an injection or vaccination',
    'Severe abdominal pain',
    'Allergic reaction',
    'Baby <=3 months old with fever',
    'Blood, such as vomiting blood, bleeding from rectum or having black stools',
    'Broken bones',
    'Burns',
    'Chest pain',
    'Cuts or lacerations',
    'Eye pain or sudden loss of vision',
    'Falls, especially those who are elderly, are very young, on blood thinners, or children who have fallen at a rate of 2-3 times their height'
  ],
  COVID_DAILOG_CONTENT: [
    'Internal medicine, family medicine, and dermatology are currently available to book. Other specialties are coming in the future!',
    'Please call directly to the clinic if you are not seeing your provider in the list.',
    'Online booking is not available for affiliated providers.'
  ],
  DIALOG_TYPE: {
    SPECIALTY_OR_MY_DOCTOR: 'SpecialtyOrMyDoctor',
    VISIT_TYPE: 'VisitType',
    LOCATION_PREFERENCE: 'LocationPreference'
  },
  DIALOG_TITLE: {
    SPECIALTY_OR_MY_DOCTOR: "Don't see what you're looking for?",
    VISIT_TYPE: 'More information about visit types',
    LOCATION_PREFERENCE: 'More information about location preferences'
  },
  DIALOG_CONTENT: {
    SPECIALTY_OR_MY_DOCTOR: {
      SECTION_ONE_TEXT: `The specialties below are currently available to book. Other specialties are coming in the future! `,
      SPECIALTIES_TITLE: 'Specialties ',
      SPECIALTIES_DESCRIPTION: 'in medicine is a branch of medical practice.',
      ACTIVE_SPECIALTY_TEXT: `Online scheduling is available for new and returning patients in the following specialties:`,
      SPECIALTIES: [
        {
          title: 'Family Medicine ',
          description:
            'is the branch of medicine designed to provide health care to all members of the family.'
        },
        {
          title: 'Internal Medicine ',
          description:
            'is the medical specialty dealing with the prevention, diagnosis, and treatment of adult diseases'
        },
        {
          title: 'Behavioral Health Connect Care ',
          description:
            'is the medical specialty focused on the diagnosis, treatment, and prevention of mental, emotional, and behavioral disorders. All visits will be done over video.'
        },
        {
          title: 'Dermatology ',
          description:
            'is the medical specialty that deals with conditions of the skin, scalp, hair, and nails.'
        },
        {
          title: 'Sports Medicine ',
          description:
            'is the field of medicine concerned with the prevention and treatment of injury and disorders that are related to participation in sports.'
        },
        {
          title: 'Podiatry ',
          description:
            'is the branch of medicine dealing with the treatment of the feet and their ailments.'
        }
      ],
      INACTIVE_SPECIALTY_TEXT: `Online scheduling is available for returning patients only in the following specialties:`,
      SPECIALTIES_INACTIVE: [
        {
          title: 'Behavioral Health ',
          description:
            'is the medical specialty focused on mental wellbeing and the prevention, diagnosis, and treatment, of mental, emotional, behavioral and addictive disorders.'
        },
        {
          title: 'OB/Gyn (Obstetrics & Gynecology) ',
          description:
            'is the branch of medicine that specializes in the care of women during pregnancy and childbirth, in the diagnosis and treatment of diseases of the female reproductive organs. It also specializes in other women’s health issues, such as menopause, hormone problems, birth control, and infertility.'
        },
        {
          title: 'Orthopedics ',
          description:
            'is the branch of medicine that focuses on correction, prevention and treatment of bones, joints, muscles, ligaments, tendons, and nerves.'
        },
        {
          title: 'Pediatric Diabetes ',
          description:
            'is a medical service that specializes in treating children from 0-18 for those diagnosed with diabetes.'
        },
        {
          title: 'Pediatric Gastroenterology ',
          description:
            'is a medical service that specializes in treating children from newborns to adolescents for common and complex gastrointestinal, liver, or growth disorders.'
        },
        {
          title: 'Pediatric Gynecology ',
          description:
            'is a medical service that specializes in treating children for pediatric gynecological disorders.'
        }
      ],
      OBGYN_TITLE: 'OB/Gyn (Obstetrics & Gynecology) ',
      OBGYN_DESCRIPTION:
        'is the branch of medicine that specializes in the care of women during pregnancy and childbirth, in the diagnosis and treatment of diseases of the female reproductive organs. It also specializes in other women’s health issues, such as menopause, hormone problems, contraception (birth control), and infertility.',
      PEDIATRICS_TITLE: 'Pediatrics ',
      PEDIATRICS_DESCRIPTION:
        'is the specialty of medical science concerned with the physical, mental, and social health of children from birth to young adulthood. Pediatric care encompasses a broad spectrum of health services ranging from preventive health care to the diagnosis and treatment of acute and chronic diseases.',
      SECTION_TWO_TEXT:
        'Please call directly to the clinic if you are not seeing your provider in the list.',
      SECTION_THREE_TEXT: 'Online booking is not available for affiliated providers.'
    },
    LOCATION_PREFERENCE: {
      SECTION_ONE_TEXT: [
        'Review the guidelines below and then book accordingly.',
        `In many situations, a video visit can be an excellent way to practice social distancing while getting the healthcare you need. At ${CompanyName}, we conduct thousands of video visits each day.`,
        'Not all issues can be properly diagnosed and treated via video visit, and it is possible that your provider will contact you to transition your video visit to an in-person visit.'
      ],
      SECTION_TWO_TITLE: 'A video visit is recommended:',
      SECTION_TWO_SUBTITLE_ONE:
        'If you are looking to see your provider for any of the following situations:',
      SECTION_TWO_LIST_ITEMS_ONE: [
        'Mental health visits',
        'Chronic disease follow-up',
        'Medicare annual wellness visits',
        'Acute and chronic conditions that require discussion and visualization but no hands-on exam or treatment',
        'Medication renewals that require a visit to review'
      ],
      SECTION_TWO_SUBTITLE_TWO:
        'If you (or someone you live with) has potential COVID-19 symptoms:',
      SECTION_TWO_LIST_ITEMS_TWO: [
        'Fever',
        'New or worsening cough',
        'Shortness of breath',
        'Body ache(s)',
        'Reduced sense of smell',
        'Sore throat',
        'Diarrhea',
        'Runny or stuffy nose'
      ],
      SECTION_TWO_SUBTITLE_THREE:
        'If you (or someone you live with) is at high risk of complications from COVID-19:',
      SECTION_TWO_LIST_ITEMS_THREE: [
        'Over 60 years old',
        'Receiving chemotherapy or other treatments for cancer or other diseases',
        'Have had bone marrow transplant',
        'Who are on immunosuppressive medication that purposefully suppresses your immune system -- for example, treatment for rheumatoid arthritis',
        'Taking opioid medications'
      ],
      SECTION_THREE_TITLE:
        'However, an in-person visit is required in the following situations (if urgent, call your provider to schedule or visit your local Instacare):',
      SECTION_THREE_LIST_ITEMS_ONE: [
        'Well child checks',
        'Routine physical exams',
        'Conditions or visits that require a treatment, such as an injection or vaccination',
        'Minor abdominal pain',
        'Minor allergic reaction',
        'Minor broken bones',
        'Minor cuts/lacerations',
        'Minor falls'
      ],
      SECTION_FOUR_TITLE: SYMPTOMS.EMERGENCY_TITLE,
      SECTION_FOUR_LIST_ITEMS_ONE: [...EMERGENCY_SYMPTOMS],
      FOOTER_TITLE: [
        'Still uncertain about what option is best for you? Call your provider to discuss your situation further.'
      ]
    }
  }
};
